import { OrgAdminRoleType } from '@/const/user';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export type AddInternalOrganizationUserRolePayloadType = {
  user_id: string;
  role: OrgAdminRoleType;
};

export const addInternalOrganizationUserRoleApi = async (
  data: AddInternalOrganizationUserRolePayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/internal/users/user:add/`;

  return authApiService.POST(uri, data);
};
